module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Motherless")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0008-02-1"
    }
  }, [_c('i', [_vm._v("One day the ocean left us.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0008-02-2"
    }
  }, [_c('i', [_vm._v("She unplugged the drain ")]), _c('br'), _c('i', [_vm._v("And ran out ")]), _c('br'), _c('i', [_vm._v("Took her lullaby waters and salt perfume ")]), _c('br'), _c('i', [_vm._v("To a less demanding world.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0008-03-4"
    }
  }, [_c('i', [_c('br'), _vm._v("Now we abandoned boats tilt in crusty sand ")]), _c('br'), _c('i', [_vm._v("Punished ")]), _c('br'), _c('i', [_vm._v("Guilty of needing the sea ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("But ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('i', [_vm._v("Underneath one half-buried hull ")]), _c('br'), _c('i', [_vm._v("Gritty grains still hold water. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0008-05-6"
    }
  }, [_c('i', [_vm._v("They are wet enough to grow belief ")]), _c('br'), _c('i', [_vm._v("That truly the ocean once was here ")]), _c('br'), _c('i', [_vm._v("And that even now ")]), _c('br'), _c('i', [_vm._v("She remains.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YLAN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECKER")]), _vm._v(", “M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHER")]), _vm._v("” "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" "), _c('i', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("TO")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URVIVE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd64646","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 78
// module chunks = 0